module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_waso_yoso-0a6dc3a124968bdb95b4b3965506b42d.webp";